import React from "react";
import { framework_tool, component_tool, utils_tool } from '../../../../../tool'
import moment from "moment";
import { WizTableForm } from "../../../../common";

let { WizOssUpload, WizAvatarUpload, ossFileUtils, WizFileUpload, WizUpload } = framework_tool
let { Wizmessage, WizInputNumber, WizRow, WizCol, WizButton, WizIcon } = component_tool
let { $$ } = utils_tool

const _getValue = (type, key) => {
  const values = {
    partType: {
      0: '课程',
      1: '考试',
      2: '投票',
      3: '系列化课程',
      4: '图片',
      5: '链接',
      6: '视频',
    },
  }
  return values[type][key]
}

const defaultImg = (fileId) => {
  let imgs = []
  imgs.push({ url: getOssFilePath(fileId), uid: new Date().getTime() + fileId })
  return imgs
}

const defaultImgList = (fileIds) => {
  let imgs = []
  let fileList = fileIds && fileIds.split(',')

  if (fileList && fileList.length && fileList.length > 0) {
    fileList.forEach(fileId => {
      imgs.push({ url: getOssFilePath(fileId), uid: new Date().getTime() + fileId })
    })
  }
  return imgs
}

function _time(time = +new Date()) {
  let date = new Date(time + 8 * 3600 * 1000); // 增加8小时
  return date.toJSON().substr(0, 19).replace('T', ' ');
}

export default (self, initialValue) => {
  let { title } = initialValue
  const _getEntityInfo = (e) => {
    let labelIds = Object.values(e).map(val => {
      return { id: val.id, name: val.title || val.name }
    })
    title = labelIds.map(value => value.name).toString()
    self.setState({ selectValue: title })
  }

  let entityConfig = WizTableForm.Config.program(this, { apiParams: { status: 1, littleTime: _time()} });
  switch (initialValue.type) {
    case 1:
      entityConfig = WizTableForm.Config.exam(this, { apiParams: { status: 1, littleTime: _time() } });
      break;
    // case 2
    case 3:
      entityConfig = WizTableForm.Config.series(this, { apiParams: { state: 1 } })
  }

  let dateFormat = "YYYY-MM-DD HH:mm"
  let columns = []
  columns = columns.concat([
    {
      name: 'id',
      formItem: {
        type: 'hidden',
        initialValue: initialValue.id
      }
    },
    {
      name: 'activityId',
      formItem: {
        type: 'hidden',
        initialValue: initialValue.activityId
      }
    },
    {
      title: '活动类型',
      name: 'type',
      formItem: {
        initialValue: initialValue.type,
        disabled: true,
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 2, codeName: '投票' },
        { code: 3, codeName: '系列化课程' },
        { code: 4, codeName: '图片' },
        { code: 5, codeName: '链接' },
        { code: 6, codeName: '视频' },
      ]
    },
  ])

  if (initialValue && initialValue['type'] <= 3) {
    columns = columns.concat([
      {
        title: '关联' + _getValue('partType', initialValue.type),
        name: 'entityId',
        formItem: {
          ...entityConfig,
          diy: WizTableForm,
          initialValue: initialValue.entityId,
          formatInit: (record) => {
            return initialValue.entityId
          },
          initRows: [{
            id: initialValue.entityId,
            name: initialValue.entityName,
            title: initialValue.entityName
          }],
          onChangeRowMap: (e) => {
            _getEntityInfo(e)
          },
          selectType: 'radio',
          rules: [
            {
              required: true,
              message: '请选择关联实体'
            }
          ],
        }
      },
    ])
  }

  columns = columns.concat([
    {
      title: '环节名称',
      name: 'title',
      formItem: {
        maxLength: 20,
        placeholder: '环节名称最多输入20个字',
        initialValue: initialValue.title,
        rules: [
          {
            required: true,
            message: '请输入环节名称'
          }
        ],
      }
    },
    {
      title: '环节时间',
      name: 'activityPartTime',
      formItem: {
        type: 'date~',
        rules: [
          {
            required: true,
            message: '请选择活动时间'
          }
        ],
        showTime: true,
        format: 'YYYY-MM-DD HH:mm',
        initialValue: initialValue.startTime ? [moment(initialValue.startTime, dateFormat), moment(initialValue.endTime, dateFormat)] : null
      }
    },
  ])

  if (initialValue && initialValue['type'] === 4) {
    columns = columns.concat([
      {
        title: '图片',
        name: 'fileIds',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            let { changeImg } = self.state
            let children = changeImg && changeImg.length >= 9 ? null : <WizButton>上传图片</WizButton>
            return (
              <div>
                {
                  getFieldDecorator('fileList', {
                    initialValue: (initialValue && initialValue.fileIds) ? defaultImgList(initialValue.fileIds) : [],
                    rules: [
                      {
                        required: true,
                        message: '请选择图片'
                      }
                    ],
                  })(
                    <WizOssUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      uploadType={'activityPart'}
                      onChange={(files) => {
                        self.setState({
                          changeImg: files,
                          changeImgTime: new Date()
                        })
                      }}
                      children={children}
                    />
                  )}
              </div>
            )
          }
        }
      },
    ])
  }

  if (initialValue && initialValue['type'] === 5) {
    columns = columns.concat([
      {
        title: '链接图片',
        name: 'coverImg',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            let { changeLinkImg } = self.state
            let children = changeLinkImg && changeLinkImg.length >= 1 ? null : <WizButton>上传图片</WizButton>
            return (
              <>
                {getFieldDecorator('cover', {
                  rules: [{ required: true, message: '请上传链接图片' }],
                  initialValue: (initialValue && initialValue.coverImg) ? defaultImg(initialValue.coverImg) : [],
                })(
                  <WizOssUpload
                    key='linkImg'
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    uploadType={'activityPart'}
                    onChange={(files) => {
                      self.setState({
                        changeLinkImg: files,
                        changeLinkImgTime: new Date()
                      })
                    }}
                    children={children}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '链接地址',
        name: 'linkUrl',
        formItem: {
          initialValue: initialValue.linkUrl,
          rules: [
            {
              required: true,
              message: '请输入链接地址'
            },
            {
              pattern: /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/,
              message: '请输入正确格式的URL'
            },
          ]
        }
      },
      {
        title: '链接描述',
        name: 'linkRemark',
        formItem: {
          maxLength: 200,
          placeholder: '链接描述最多输入200个字',
          initialValue: initialValue.linkRemark,
          type: 'textarea'
        }
      },
    ])
  }

  if (initialValue && initialValue['type'] === 6) {
    columns = columns.concat([
      {
        title: '视频封面图片',
        name: 'coverImg',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            let { changeVideoImg } = self.state
            let children = changeVideoImg && changeVideoImg.length >= 1 ? null : <WizButton>上传图片</WizButton>
            return (
              <>
                {getFieldDecorator('cover', {
                  rules: [
                    {
                      required: true,
                      message: '请上传视频封面图片'
                    }
                  ],
                  initialValue: (initialValue && initialValue.coverImg) ? defaultImg(initialValue.coverImg) : [],
                })(
                  <WizOssUpload
                    key='videoCoverImg'
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    uploadType={'activityPart'}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                    onChange={(files) => {
                      self.setState({
                        changeVideoImg: files,
                        changeVideoImgTime: new Date()
                      })
                    }}
                    children={children}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '上传视频',
        name: 'fileIds',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            let { changeVideo, changeVideoTime } = self.state
            let children = changeVideo && changeVideo.length >= 1 ? null : <WizButton>上传视频</WizButton>
            return (
              <>
                {getFieldDecorator('fileList', {
                  rules: [
                    {
                      required: true,
                      message: '请上传视频'
                    }
                  ],
                  initialValue: (initialValue && initialValue.fileIds) ? defaultImg(initialValue.fileIds) : []
                })(
                  <WizOssUpload
                    key={changeVideoTime || 'videoFile'}
                    accept={'video/mp4'}
                    listType={'picture-card'}
                    uploadType={'activityPart'}
                    beforeUpload={(file, upload, remove) => {
                      let result = true;
                      const isLt300M = file.size / 1024 / 1024 < 300;
                      if (file.type.indexOf('mp4') == -1) {
                        Wizmessage.error('只能上传视频格式为mp4的文件!');
                        result = false;
                      } else if (!isLt300M) {
                        Wizmessage.error('视频不得超过300MB!');
                        result = false;
                      }
                      if (self.state && self.state.changeVideo && self.state.changeVideo.length) {
                        wizNotice.error('只能上传一个视频');
                        result = false;
                      }
                      if (!result) {
                        remove && remove()
                        self.setState({
                          changeVideoTime: new Date()
                        })
                      }
                      return result
                    }}
                    onChange={(files) => {
                      self.setState({
                        changeVideo: files,
                      })
                    }}
                    children={children}
                  />
                )}
              </>
            )
          }
        }
      },
    ])
  }

  columns = columns.concat([
    {
      title: '积分',
      name: 'score',
      formItem: {
        initialValue: 0,
        type: "hidden"
      }
    },
    // {
    //   title: '积分',
    //   name: 'score',
    //   formItem: {
    //     type: 'custom',
    //     render: (record, form) => {
    //       const {getFieldDecorator} = form;
    //       return (
    //         <WizRow>
    //           <WizCol>
    //             {getFieldDecorator('score', {
    //               rules: [
    //                 {
    //                   pattern: /^(0)$|^[1-9]\d{0,8}$$/,
    //                   message: '积分建议不要过长且首位不能为0'
    //                 }
    //               ],
    //               initialValue: initialValue.score != null ? initialValue.score : 0,
    //             })(<WizInputNumber min={0}/>)}
    //           </WizCol>
    //         </WizRow>
    //       )
    //     }
    //   }
    // },
    {
      title: '状态',
      name: 'active',
      formItem: {
        initialValue: initialValue.active != null ? initialValue.active : 1,
        type: 'radio'
      },
      dict: [
        { code: 1, codeName: '打开' },
        { code: 0, codeName: '关闭' }
      ]
    },
    {
      title: '简介',
      name: 'remark',
      formItem: {
        maxLength: 200,
        placeholder: '简介最多输入200个字',
        initialValue: initialValue.remark,
        type: 'textarea'
      }
    },
  ])

  return columns
}
